import React from "react";
import "./Program_Overview.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Program_Overview = ({ program }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="Program_Overview" ref={ref}>
      <div className="container">
        <p className="program_heading_text">{program?.name}</p>

        <div className="Program_Overview_header">
          <h5>
            Program <span>Overview</span>
          </h5>
        </div>

        <p
          className="program_text"
          dangerouslySetInnerHTML={{
            __html: program?.overview,
          }}
        />

        <div className="blue_div">
          <div className="row justify-content-center align-items-center">

            <div className="col-lg-2 col-md-2 col-sm-4 col-6 mb-2 border_col">
              <div className="blue_text">
                <h5>
                  {inView && (
                    <CountUp end={2000} duration={2} />
                  )}
                  +
                </h5>
                <p>Learners</p>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-4 col-6 mb-2 border_col">
              <div className="blue_text">
                <h5>
                  {inView && (
                    <CountUp end={300} duration={2} />
                  )}
                  +
                </h5>
                <p>Hiring Partners</p>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-4 col-6 mb-2 border_col">
              <div className="blue_text">
                <h5>
                  {inView && (
                    <CountUp start={7} end={12} duration={2} />
                  )}
                  +
                </h5>
                <p>Yr Expert Mentors</p>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-4 col-6 mb-2 border_col">
              <div className="blue_text">
                <h5>
                  {inView && (
                    <CountUp end={50} duration={2} />
                  )}
                  +
                </h5>
                <p>Projects</p>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-4 col-6 mb-2 border_col">
              <div className="blue_text">
                <h5>
                  {inView && (
                    <CountUp end={90} duration={2} />
                  )}
                  %
                </h5>
                <p>Career Growth</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Program_Overview;